var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.position,"title":_vm.title,"draggable":false}},[_c('l-icon',{attrs:{"icon-url":_vm.icontest}}),_c('l-popup',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }